<template>
  <svg
    width="354"
    height="132"
    viewBox="0 0 354 132"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M123 50V115H12V108.335C61.4868 108.335 75.3037 50.3483 122.575 50.0041C122.716 50 122.858 50 122.998 50H123Z"
      fill="#FFE7C0"
    />
    <path
      d="M234 114.998H123L123 50C125.43 50 127.77 50.1507 130.033 50.442C172.11 55.8032 186.897 108.333 233.998 108.333V114.998H234Z"
      fill="#FFE7C0"
    />
    <path
      d="M268.5 74V121H187V116.181C223.335 116.181 233.48 74.2519 268.188 74.0029C268.291 74 268.396 74 268.499 74H268.5Z"
      fill="#FFE7C0"
    />
    <path
      d="M350 120.999H268.5L268.5 74C270.284 74 272.002 74.109 273.664 74.3196C304.558 78.1961 315.416 116.179 349.999 116.179V120.999H350Z"
      fill="#FFE7C0"
    />
    <path d="M250.259 73H246.27V114.875H250.259V73Z" fill="#524630" />
    <path
      d="M277.508 73.0638C277.508 89.1998 264.42 102.264 248.254 102.264V43.8633C264.42 43.8633 277.508 56.9527 277.508 73.0638Z"
      fill="#0BEB80"
    />
    <path
      d="M248.254 43.8633V102.264C232.114 102.264 219 89.1998 219 73.0638C219 56.9277 232.114 43.8633 248.254 43.8633Z"
      fill="#33997C"
    />
    <path d="M308.76 67H304.22V114.663H308.76V67Z" fill="#524630" />
    <path
      d="M339.779 67.3763C339.779 85.7435 324.881 100.614 306.48 100.614V34.1387C324.881 34.1387 339.779 49.0391 339.779 67.3763Z"
      fill="#0BEB80"
    />
    <path
      d="M306.48 34.1392V100.612C288.109 100.612 273.182 85.7416 273.182 67.3743C273.182 49.0071 288.109 34.1367 306.48 34.1367V34.1392Z"
      fill="#33997C"
    />
    <path
      d="M354 123.381C353.996 128.144 350.918 132 347.128 132H347.113L6.86359 131.368C3.06721 131.36 -0.00625854 127.491 9.5705e-06 122.723C0.00418831 117.957 3.08601 114.102 6.87822 114.102H6.88449L249.475 114.553L327.12 114.694L335.051 114.713L342.983 114.726L347.132 114.734C348.942 114.739 350.586 115.618 351.812 117.052C353.16 118.631 354.002 120.882 353.998 123.381H354Z"
      fill="#5C4814"
    />
    <path
      d="M75.1348 43.627V115.666H96.8799L83.9062 72.695L83.4148 71.0676L75.1348 43.627Z"
      fill="#0BEB80"
    />
    <path d="M75.1348 43.627V115.662H53.3916L75.1348 43.627Z" fill="#33997C" />
    <path d="M173.689 90H171.354V114.521H173.689V90Z" fill="#524630" />
    <path
      d="M189.649 90.9316C189.649 100.382 181.983 108.031 172.519 108.031V73.8301C181.986 73.8301 189.649 81.4966 189.649 90.9291V90.9316Z"
      fill="#0BEB80"
    />
    <path
      d="M172.516 73.832V108.033C163.064 108.033 155.386 100.384 155.386 90.9336C155.386 81.4836 163.066 73.8345 172.516 73.8345V73.832Z"
      fill="#33997C"
    />
    <path
      d="M113.148 61.5254V115.024H129.297L119.661 83.1143L119.298 81.9037L113.148 61.5254Z"
      fill="#0BEB80"
    />
    <path d="M113.148 61.5254V115.021H97L113.148 61.5254Z" fill="#33997C" />
    <path
      d="M36.875 15.6602V115.665H67.0626L49.0524 56.0149L48.3694 53.754L36.875 15.6602Z"
      fill="#0BEB80"
    />
    <path d="M36.8755 15.6602V115.661H6.69238L36.8755 15.6602Z" fill="#33997C" />
    <path d="M212.78 83H209.748V114.851H212.78V83Z" fill="#524630" />
    <path
      d="M233.508 82.3975C233.508 94.6716 223.552 104.61 211.255 104.61V60.1895C223.552 60.1895 233.508 70.146 233.508 82.402V82.3975Z"
      fill="#0BEB80"
    />
    <path
      d="M211.259 60.1842V104.605C198.981 104.605 189.006 94.6664 189.006 82.3922C189.006 70.1181 198.981 60.1797 211.259 60.1797V60.1842Z"
      fill="#33997C"
    />
    <path d="M335.373 86H332.646V114.624H335.373V86Z" fill="#524630" />
    <path
      d="M354 86.7194C354 97.7492 345.054 106.683 334 106.683V66.7598C345.05 66.7598 354 75.7081 354 86.7231V86.7194Z"
      fill="#0BEB80"
    />
    <path
      d="M334 66.7595V106.683C322.965 106.683 314 97.7527 314 86.7192C314 75.6858 322.965 66.7559 334 66.7559V66.7595Z"
      fill="#33997C"
    />
    <path
      d="M104.939 107.444V116.011H85.9111V107.444C85.9111 102.201 90.1712 97.9492 95.4261 97.9492C100.681 97.9492 104.939 102.201 104.939 107.444Z"
      fill="#0BEB80"
    />
    <path
      d="M95.4261 97.9492V116.011H85.9111V107.444C85.9111 102.201 90.1712 97.9492 95.4261 97.9492Z"
      fill="#33997C"
    />
  </svg>
</template>
